export const setCookie = (name, value, options = {}) => {
  let cookieString = `${name}=${value}; path=/`;

  if (options.expires) {
    let date = new Date();
    date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000); // expires in days
    cookieString += `; expires=${date.toUTCString()}`;
  }

  if (options.secure) {
    cookieString += `; secure`;
  }

  document.cookie = cookieString;
};

export const getCookie = name => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

export const removeCookie = name => {
  document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};
